import cn from 'classnames';

import { useSetTab, useTab } from '@/components/Tabs/useTab';
import { Button, ButtonGroup } from '@/design-system';
import { capitalize } from '@/utils/stringUtils';

import { COMPARE_EXPERIMENT_TAB_SEARCH_PARAM_PREFIX } from './constants';
import { CompareExperimentTabs } from './types';

export function CompareExperimentsTabs() {
  const setTab = useSetTab({
    method: 'merge',
    prefix: COMPARE_EXPERIMENT_TAB_SEARCH_PARAM_PREFIX,
  });
  const tab = useTab({
    defaultIndex: 0,
    prefix: COMPARE_EXPERIMENT_TAB_SEARCH_PARAM_PREFIX,
  });

  return (
    <ButtonGroup variant="plain" color="secondary" size="md">
      {Object.keys(CompareExperimentTabs).map((tabName) => {
        const value = CompareExperimentTabs[tabName];
        const isSelected = tab === value;

        return (
          <Button
            key={tabName}
            onClick={() => setTab(value)}
            className={cn(isSelected && 'bg-tertiary')}
          >
            {capitalize(tabName.toLowerCase())}
          </Button>
        );
      })}
    </ButtonGroup>
  );
}
